import RentableUnitNotFound from './RentableUnitNotFound';

export default RentableUnitNotFound;
